import pick from 'lodash/pick';
import { getIsHookFormOptionRequired } from '../getIsHookFormOptionRequired';
import { useHookForm } from '../useHookForm/useHookForm';
import { hookFormFieldWrapperProps } from './utils/hookFormFieldWrapperProps';
/**
 * Represents a hook for creating a React Hook Form based component wrapped in
 * {@link FieldWrapper}.
 */
export function useHookFormFieldWrapper(props) {
    var _a, _b, _c, _d;
    const { controller, controllerProps } = useHookForm(props);
    const fieldWrapperProps = Object.assign(Object.assign({}, pick(props, hookFormFieldWrapperProps)), { required: getIsHookFormOptionRequired((_a = controllerProps.rules) === null || _a === void 0 ? void 0 : _a.required), meta: {
            touched: controller.fieldState.isTouched,
            error: (_b = controller.fieldState.error) === null || _b === void 0 ? void 0 : _b.message,
            success: (_c = props.meta) === null || _c === void 0 ? void 0 : _c.success,
            warning: (_d = props.meta) === null || _d === void 0 ? void 0 : _d.warning,
        }, labelFor: controllerProps.name });
    return {
        controller,
        controllerProps,
        fieldWrapperProps,
    };
}
